
    <div>
        <h4 [innerHTML]=waitingText></h4>
        <div style="display: flex; justify-content: center; align-items: center;">
            <img src="../assets/loading.gif" style="width: 150px; height: 150px;">
        </div>
    </div>